import { RefObject, useEffect } from "react";

type TRef = RefObject<HTMLElement>;
type TCallback = () => void;

const useClickOutside = (ref: TRef, cb: TCallback) => {
  useEffect(() => {
    const handleOutside = (event: Event) => {
      if (!ref.current?.contains(event.target as Node)) {
        cb();
      }
    };

    document.addEventListener("keyup", handleOutside);
    document.addEventListener("mousedown", handleOutside);

    return () => {
      document.removeEventListener("keyup", handleOutside);
      document.removeEventListener("mousedown", handleOutside);
    };
  }, [ref, cb]);
};

export default useClickOutside;
